import React, { useState } from 'react';
import { useAuth } from '../../../lib/auth/AuthContext';
import { Input } from '../../../shared/components/Input';
import { Checkbox } from '../../../shared/components/Checkbox';
import { Button } from '../../../shared/components/Button';
import { EmailIcon, LockIcon } from '../../../shared/components/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(() => {
    const state = (window.history.state?.usr) as any;
    return state?.accessDenied
      ? 'Your account is not authorised to access this application. Please contact your administrator.'
      : '';
  });
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const result = await signIn(email, password);
      if (result.isSignedIn) {
        // Get the redirect path from location state or default to dashboard
        const from = (location.state as any)?.from?.pathname || '/dashboard';
        navigate(from, { replace: true });
      }
    } catch (error: any) {
      if (error?.message === 'NO_GROUP_ACCESS') {
        setError('Your account is not authorised to access this application. Please contact your administrator.');
      } else {
        setError('Invalid email or password');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-page-bg py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-8">
        <div className="inline-block">
          <div className="text-4xl">
            <span className="text-hero-red font-bold">DATA </span>
            <span className="text-text-grey">360</span>
          </div>
          <div className="text-xl text-text-grey" style={{ marginTop: '-4px' }}>Sales ToolKit</div>
        </div>
      </div>
      <div className="max-w-md w-full bg-white rounded-xl border border-[#E2E5EA] shadow-lg p-8">
        <div className="text-center mb-6">
          <h2 className="text-text-grey">Sign in to your account</h2>
          {error && (
            <div className="mt-2 text-sm text-readable-red">
              {error}
            </div>
          )}
        </div>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-5">
            <Input
              id="email"
              type="email"
              label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              icon={<EmailIcon />}
              required
            />

            <Input
              id="password"
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              icon={<LockIcon />}
              required
            />

            <Checkbox
              id="remember-me"
              label="Remember me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
          </div>

          <div className="pt-4">
            <Button
              type="submit"
              variant="primary"
              fullWidth
              isLoading={isLoading}
              className="shadow-sm"
            >
              Sign in
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login; 